import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { Building } from 'app/classes/building';
import { Gateway } from 'app/classes/gateway';
import { Org } from 'app/classes/org';
import { APIService } from 'app/shared/api.service';
import { BuildingsService } from 'app/shared/buildings.service';
import { DateService } from 'app/shared/date.service';
import { InsightsService } from 'app/shared/insights.service';
import { SiteService } from 'app/shared/site.service';
import { Subscription } from 'rxjs';
import { IBuildingQuickPick } from '../aq-collections/aq-collections.component';

@Component({
  selector: 'app-insights-floors',
  standalone: false,
  templateUrl: './insights-floors.component.html',
  styleUrl: './insights-floors.component.css'
})
export class InsightsFloorsComponent implements OnInit {

  readonly LOCALSTORAGE = 'iafloors:config';

  @ViewChild('bottomMarker') bottomMarker!: ElementRef;

  previousBuildings = signal<IBuildingQuickPick[]>(null);
  isGettingBuilding = signal<boolean>(false);
  buildings = signal<Building[]>(null);
  building = signal<Building>(null);
  dialogOpen = signal<'buildings' | 'configure' | 'aq-select'>(null);
  buildingForReport = signal<Building>(null);
  gateways: Gateway[];
  gatewaysSelected: Gateway[];
  month: Date;
  subs: Subscription[] = [];
  runReport: boolean;
  reportWasGenerated: boolean;
  reportWasGeneratedAt: Date;
  // Re-run report with latest data if true
  clearCache: boolean;
  org: Org;
  today = new Date();
  useOrgLogo: boolean;
  response: any;
  p1_start: Date;
  p1_end: Date;
  p2_start: Date;
  p2_end: Date;


  report: any;

  constructor(private apiService: APIService, private buildingService: BuildingsService, public siteService: SiteService, private insightsService: InsightsService) {
    this.getLocalStorage();
    this.month = DateService.getDateStartOfMonth(new Date());
  }

  getLocalStorage() {
    const ls = localStorage.getItem(this.LOCALSTORAGE);
    if (ls) {
      const { useOrgLogo, clearCache, previous, p1_start, p1_end, p2_start, p2_end } = JSON.parse(ls);
      this.previousBuildings.set(previous);
      this.useOrgLogo = useOrgLogo;
      this.clearCache = clearCache;
      if (p1_start && p1_end && p2_start && p2_end) {
        this.p1_start = new Date(p1_start);
        this.p1_end = new Date(p1_end);
        this.p2_start = new Date(p2_start);
        this.p2_end = new Date(p2_end);
      }
    }
  }

  ngOnInit(): void {
    const buildingSub = this.buildingService.buildingList.subscribe(list => {
      if (!list) {
        return;
      }
      this.buildings.set(list);
    });

    this.subs.push(buildingSub);
    this.org = this.apiService.getUserOrg();
  }

  buildingChange(building: Building) {
    this.dialogOpen.set(null);

    if (!building) {
      return;
    }

    this.building.set(building);
    this.addToPreviousBuildings(building);
    this.runReport = false;
    this.reportWasGenerated = false;
    this.buildingForReport.set(null);
    this.getBuilding(this.building().id);
  }

  async getBuilding(id: number) {
    this.isGettingBuilding.set(true);

    const building = await this.buildingService.getOne(id, 'aq=1');
    console.log('Building data loaded', building.id);

    this.buildingForReport.set(building);
    this.isGettingBuilding.set(false);
  }

  addToPreviousBuildings(building: Building) {
    this.previousBuildings.set([{ id: building.id, title: building.title }]);
  }

  generate() {
    this.runReport = true;
    this.saveLocalStorage();

    this.report = null;

    this.insightsService.getOutcomeInsights(this.buildingForReport().id, { start: this.p1_start, end: this.p1_end }, { start: this.p2_start, end: this.p2_end }).then((response) => {
      this.reportWasGenerated = true;
      this.reportWasGeneratedAt = new Date();

      console.log(response);
      this.report = response;

      this.response = JSON.stringify(response, null, 2);
      setTimeout(() => {
        this.scrollToBottom();
      }, 1);

    });


  }

  saveLocalStorage() {
    const payload = JSON.stringify({ previous: this.previousBuildings(), p1_start: this.p1_start, p1_end: this.p1_end, p2_start: this.p2_start, p2_end: this.p2_end });
    localStorage.setItem(this.LOCALSTORAGE, payload);
  }

  scrollToBottom(): void {
    if (this.bottomMarker) {
      this.bottomMarker.nativeElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback: Scroll to bottom of window
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      });
    }
  }
}


